import { useMediaQuery, useTheme } from '@mui/material';
import Card from '@mui/material/Card';
import type React from 'react';

type EpharmCardProps = {
  nextButtonText?: string;
  previousButtonText?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  previousButtonDisabled?: boolean;
  content: React.ReactNode;
};

function EpharmCard({
  nextButtonText,
  previousButtonText,
  onNext,
  onPrevious,
  previousButtonDisabled = false,
  content,
}: EpharmCardProps) {
  const hasButtons = !!nextButtonText || !!previousButtonText;
  const hasPreviousButton = !!previousButtonText;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <Card
      sx={{
        width: isMobile ? '100%' : '40vw',
        height: isMobile ? '40vh' : '65vh',
        borderRadius: 2,
        minHeight: '500px',
        maxHeight: '700px',
      }}
      variant="outlined"
    >
      <div id="content-container">
        <div
          id="card-content"
          style={{
            borderBottom: hasButtons ? '1px solid #e0e0e0' : 'none',
          }}
        >
          <div style={{ flex: 10 }}>{content}</div>
        </div>
        {hasButtons ? (
          <div
            id="card-buttons"
            style={{
              justifyContent: hasPreviousButton ? 'space-between' : 'flex-end',
            }}
          >
            {!!previousButtonText && (
              <button
                className="btn previous-button"
                type="button"
                onClick={onPrevious}
                disabled={previousButtonDisabled}
              >
                {previousButtonText}
              </button>
            )}
            {!!nextButtonText && (
              <button className="btn next-button" type="button" onClick={() => onNext?.()}>
                {nextButtonText}
              </button>
            )}
          </div>
        ) : null}
      </div>
    </Card>
  );
}

export default EpharmCard;
